import { Injectable } from '@angular/core';
import { AbstractSaveOneService } from 'src/app/modules/core/service/v2/service/save/abstractSaveOne.service';
import {AudioRecordSavePayload} from './audioRecordSave.payload';
import {AudioRecordModel} from '../../model/audioRecord.model';
import {AudioRecordRepository} from '../../../impl/service/ngrx/audioRecord.repository';
import {AudioRecordDataServiceAdapter} from '../../../impl/service/ngrx/audioRecordDataService.adapter';

@Injectable()
export class AudioRecordSaveService extends AbstractSaveOneService<AudioRecordModel, AudioRecordSavePayload> {

    constructor(repository: AudioRecordRepository, dataServiceAdapter: AudioRecordDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
